module.exports = __webpack_public_path__ + "static/image-03-a@2x-602acd346151dc614837cb959e7af272.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/deliveroo/image-03-a@2x.jpg
// module id = 357
// module chunks = 3627797113349 20562973939449 33019919093843